import React from "react";
import ProtectedRoute from "./ProtectedRoute";

// Composant qui enveloppe automatiquement toutes les routes dans ProtectedRoute
const AllRoutesProtected = ({ children, ...rest }) => {
  return <ProtectedRoute {...rest}>{children}</ProtectedRoute>;
};

export default AllRoutesProtected;
